import { Component, Inject } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TranslateService } from '@services/translate/translate.service';
import { PackageInstalledAppsService } from '@services/packages/package-installed-apps.service';
import { DynamicContentService } from '@services/dynamic-content/dynamic-content.service';
import { MessengerService } from '@services/messenger/messenger.service';
import { DynamicContentEntranceService } from '@services/dynamic-content/dynamic-content-entrance.service';
import { Models } from '@ibexfusion/models';
import * as _ from 'lodash';

@Component({
    selector: 'select-assets',
    templateUrl: './select-assets.component.html',
    styleUrls: ['./select-assets.component.scss'],
    providers: [DynamicContentService],
    standalone: false
})

export class SelectAssetsComponent {
  selectedAssets = [];
  type = 'all';
  content = [];
  contentData = [];
  multiple = true;
  private children: any = {};
  constructor(
    public dialogRef: MatDialogRef<SelectAssetsComponent>, @Inject(MAT_DIALOG_DATA) public data: any,
    private contentService: DynamicContentService
  ) {
    this.getContent();
    if (data?.page === 'package-image') {
      this.type = 'all';
      if (!data.multiple) {
        this.multiple = false;
      }
    }
    if (data?.multiple === false) {
      this.multiple = false;
    }
  }

  insertAssets() {
    this.dialogRef.close([...new Map(this.selectedAssets.map(item => [item['_id'], item])).values()]);
  }

  async loadAssets(assets) {
    this.selectedAssets = assets;
  }

  changeTab(type) {
    this.type = type;
    if (this.type === 'app') {
      this.getContent();
    }
  }

  async getContent() {
    this.content = [];
    if (this.data.parentId) {
      const dynamicContentQuery = { entranceId: this.data.parentId, withSubs: true };
      const tree = [];
      if (!dynamicContentQuery) {
        this.contentData = [];
        return;
      }
      const result = await this.contentService.find(0, 1000, dynamicContentQuery);
      if (!result?.data) {
        this.contentData = tree;
        return;
      }
      result.children?.forEach(child => {
        const item = new Models.DynamicContent();
        item.populateFromJSON(child);
        this.children[child._id] = item;
      });
      result.data = result.data.filter(element => !element.content?.date?.includes('Invalid'));
      await Promise.all(result.data.map(async entry => {
        const treeItem = await this.pushToTree(entry, 1);
        tree.push(treeItem);
      }));
      this.contentData = tree;
      this.findMedia(this.contentData);
    }
  }

  findMedia(data) {
    data.forEach(item => {
      const { dataFiles, mediaFiles } = item.data;
      if (this.data.type === 'file') {
        if (dataFiles?.length) {
          this.content = this.content.concat(dataFiles);
        }
      }
      if (this.data.type === 'image' || this.data.type === 'video') {
        mediaFiles?.forEach(media => {
          if (media.mimeType.includes('image') && this.data.type === 'image') {
            this.content = this.content.concat(media);
          } else if (media.mimeType.includes('video') && this.data.type === 'video') {
            this.content = this.content.concat(media);
          }
        });
      }

      if (item.children?.length) {
        this.findMedia(item.children);
      }
    });
  }

  private async pushToTree(item, level): Promise<any> {
    level++;
    const children = await Promise.all(
      (item.children || []).map(id => this.children[id] ? this.pushToTree(_.cloneDeep(this.children[id]), level).then(subEntry => {
        subEntry.data.parent = item._id;
        return subEntry;
      }) : console.warn(id))
    );
    children.sort((a, b) => a.data.order - b.data.order);
    return { data: { ...item, translation: [], level, children: children.map(child => child.data) }, children };
  }
}
